/**
 * Hub /app — intrare către Portal (React).
 */
export default function PortalEntryPage({ copy, adminUrl, deskUrl }) {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-[#0b1220] flex flex-col items-center justify-center px-4 py-12 antialiased">
      <div className="w-full max-w-md text-center space-y-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">{copy.eyebrow}</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0b378c] tracking-tight">{copy.title}</h1>
        <p className="text-slate-600 text-sm sm:text-base">{copy.subtitle}</p>
      </div>

      <div className="mt-10 w-full max-w-md flex flex-col sm:flex-row gap-4 sm:gap-3">
        <a
          href={adminUrl}
          className="flex-1 rounded-xl border-2 border-[#0b378c] bg-white px-5 py-4 text-center shadow-sm transition hover:bg-[#0b378c] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0b378c]"
        >
          <span className="block font-semibold">{copy.adminBtn}</span>
          <span className="mt-1 block text-xs opacity-80">{copy.adminHint}</span>
        </a>
        <a
          href={deskUrl}
          className="flex-1 rounded-xl border-2 border-[#e3191b] bg-white px-5 py-4 text-center shadow-sm transition hover:bg-[#e3191b] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#e3191b]"
        >
          <span className="block font-semibold">{copy.deskBtn}</span>
          <span className="mt-1 block text-xs opacity-80">{copy.deskHint}</span>
        </a>
      </div>

      <a
        href="/"
        className="mt-12 text-sm font-medium text-slate-500 underline-offset-4 hover:text-[#0b378c] hover:underline"
      >
        {copy.backSite}
      </a>
    </div>
  );
}
